// extracted by mini-css-extract-plugin
var _1 = "ShareDetailsStyle-module__asset-details___bPFrk";
var _2 = "ShareDetailsStyle-module__asset-details-group___bZE3h";
var _3 = "ShareDetailsStyle-module__asset-details___bPFrk";
var _4 = "ShareDetailsStyle-module__asset-details-group___bZE3h";
var _5 = "ShareDetailsStyle-module__chart-holder___xa8NC";
var _6 = "ShareDetailsStyle-module__chart-holder___xa8NC";
var _7 = "ShareDetailsStyle-module__secondary-market-tooltip___hslEy";
var _8 = "ShareDetailsStyle-module__secondary-market-tooltip___hslEy";
var _9 = "ShareDetailsStyle-module__separator___ZsBmi";
var _a = "ShareDetailsStyle-module__separator-wrapper___OHcb4";
var _b = "ShareDetailsStyle-module__separator-wrapper___OHcb4";
export { _1 as "asset-details", _2 as "asset-details-group", _3 as "assetDetails", _4 as "assetDetailsGroup", _5 as "chart-holder", _6 as "chartHolder", _7 as "secondary-market-tooltip", _8 as "secondaryMarketTooltip", _9 as "separator", _a as "separator-wrapper", _b as "separatorWrapper" }
